/* ==========================================================================
   ZELICAT THEME — video-cards.js
   "See it in action" video cards. The play button toggles a card; only one card plays at a time.
   - Card with an uploaded (Shopify-hosted) video: a muted, looping <video> is created on click.
   - Card with a YouTube / Vimeo link: an <iframe> is created on click (autoplay, muted).
   - Card without a video: the poster runs the demo animation (as in the design mockup).
   Labels come from the button's data-label-play / data-label-pause (translated in Liquid).
   ========================================================================== */
(() => {
  'use strict';
  if (!window.ZC) return;
  const { $, $$ } = window.ZC;

  const setLabel = (btn, playing) => {
    const label = btn.getAttribute(playing ? 'data-label-pause' : 'data-label-play');
    if (label) btn.setAttribute('aria-label', label);
    btn.setAttribute('aria-pressed', playing ? 'true' : 'false');
  };

  /* stop a card: remove the created player and restore the play state */
  const reset = (card) => {
    card.classList.remove('is-playing', 'is-real', 'is-embed');
    card.style.removeProperty('--vp');
    const btn = $('[data-play]', card);
    if (btn) setLabel(btn, false);
    $$('.vcard__player', card).forEach((el) => el.remove());
  };

  const start = (card, btn) => {
    const media = $('.vcard__media', card);
    const src = card.dataset.videoSrc;
    const embed = card.dataset.videoEmbed;
    card.classList.add('is-playing');
    setLabel(btn, true);

    if (src) {
      const v = document.createElement('video');
      v.className = 'vcard__player';
      v.src = src;
      v.muted = true;
      v.loop = true;
      v.playsInline = true;
      v.autoplay = true;
      v.setAttribute('aria-hidden', 'true');
      v.addEventListener('timeupdate', () => {
        if (v.duration) card.style.setProperty('--vp', String(Math.min(1, v.currentTime / v.duration)));
      });
      v.addEventListener('error', () => reset(card));
      card.classList.add('is-real');
      media.insertBefore(v, btn);
      const p = v.play();
      if (p && typeof p.catch === 'function') p.catch(() => { /* autoplay blocked: poster stays, controls stay usable */ });
    } else if (embed) {
      const f = document.createElement('iframe');
      f.className = 'vcard__player vcard__player--embed';
      f.src = embed;
      f.title = card.dataset.videoTitle || btn.getAttribute('data-label-play') || 'Video';
      f.setAttribute('allow', 'autoplay; fullscreen; picture-in-picture; encrypted-media');
      f.setAttribute('allowfullscreen', '');
      f.setAttribute('referrerpolicy', 'strict-origin-when-cross-origin');
      card.classList.add('is-real', 'is-embed');
      media.insertBefore(f, btn);
    }
    /* no src / embed: demo animation only (CSS .is-playing) */
  };

  window.ZC.mount((root) => {
    $$('[data-video]', root).forEach((card) => {
      const btn = $('[data-play]', card);
      if (!btn || !window.ZC.once(card, 'video')) return;
      btn.addEventListener('click', () => {
        const playing = card.classList.contains('is-playing');
        $$('[data-video]').forEach(reset);   // one video at a time, across the whole page
        if (playing) return;
        start(card, btn);
      });
    });
  });
})();
